export enum EBoxStatus {
    Disponivel = 1,
    Reservado = 2,
    Indisponivel = 3,
}
